export const formatCurrencyFromCents = (
  amountCents: number,
  currencyCode: string = 'GBP',
  locale: string = 'en-GB',
): string => {
  const normalizedCurrency = (currencyCode || 'GBP').toUpperCase();

  try {
    return (amountCents / 100).toLocaleString(locale, {
      style: 'currency',
      currency: normalizedCurrency,
    });
  } catch {
    const symbol = normalizedCurrency === 'GBP' ? '£' : `${normalizedCurrency} `;
    return `${symbol}${(amountCents / 100).toFixed(2)}`;
  }
};

